export default __webpack_public_path__ + "static/media/map-pin.ba9861ae.svg";